import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import styles from './styles';

/** ****************
Props Documentation:
--------------------
text : label of the filter
data: contains text, onClickHandler, isSelected,
***************** */

const FilterButtons = ({ classes, selected, options, onSwitchHandler, customClasses }) => {
  return (
    <div className={classNames(classes.filtersContainer, customClasses?.filtersContainer)}>
      {options.map(filter => (
        <Button
          key={filter?.value}
          className={classNames(classes.filterBtn, customClasses?.filterBtn, {
            [classes.selectedFilterBtn]: filter?.value === selected,
          })}
          onClick={() => onSwitchHandler(filter?.value)}
        >
          {filter?.label}
        </Button>
      ))}
    </div>
  );
};

FilterButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  selected: PropTypes.any.isRequired,
  options: PropTypes.array.isRequired,
  onSwitchHandler: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
};

FilterButtons.defaultProps = {
  customClasses: {},
};

export default withStyles(styles)(FilterButtons);
